import { LoaderContainer, Svg, CircleSpinner, CircleBackground } from './styled';
export function Loader(props) {
    const { size, label, className } = props;
    const getSize = () => {
        if (typeof size === 'number') {
            return size;
        }
        const radiusToSize = {
            xs: 6,
            sm: 12,
            md: 20,
            lg: 28,
        };
        return radiusToSize[size || 'sm'];
    };
    const s = getSize();
    const width = s * 2;
    const viewBox = `0 0 ${width} ${width}`;
    const circleCx = s;
    const circleCy = s;
    const circleStrokeWidth = Math.max(1, Math.min(4, width * 0.12));
    const circleRadius = (width - circleStrokeWidth) / 2;
    const circleCircumference = circleRadius * Math.PI * 2;
    const spinnerStrokeDashArray = circleCircumference * 0.35;
    return (<LoaderContainer aria-label={label} className={className} role="status">
      <Svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} $width={width}>
        <CircleSpinner cx={circleCx} cy={circleCy} r={circleRadius} strokeWidth={circleStrokeWidth} strokeDasharray={spinnerStrokeDashArray}/>
        <CircleBackground cx={circleCx} cy={circleCy} r={circleRadius} strokeWidth={circleStrokeWidth}/>
      </Svg>
    </LoaderContainer>);
}
